module.exports = __webpack_public_path__ + "img/home-marketegg-logo.df1904b8.png";